<script>

	import format from 'string-format'
	import {Line, mixins} from 'vue-chartjs'
	import zoomPlugin from 'chartjs-plugin-zoom'
	import {Plate} from "../../../models"

	import {LOAD_WELL_SPECTRA} from "../../../store/modules/plate"
	// import selectPlugin from 'chartjs-plugin-select'
	// import selectPlugin from './chartjs-select'
	// import zoom2Plugin from './chartjs-plugin-zoom2'
	import {mapActions} from 'vuex'


	const {reactiveProp} = mixins

	export default {
		name: 'plate-raw-chart',
		extends: Line,
		// mixins: [reactiveProp],

		data: function () {
			return {

				store_mutation_unsubscriber: null,

				// рисуемые лунки dict[well_num, dataset_i],
				// чтобы сопоставить well_num и индекс в массиве датасетов чарта
				wells: {},

				// // для проверки повторной загрузки данных
				// loaded_wells: {},

				// мин и макс значения спектров всех лунок во всех точках
				spectra_min: 0,
				spectra_max: 0,

				data: {
					labels: ['cat1', 'cat2', 'cat3',],
					datasets: [
						{
							tension: 0,
							label: 'line1',
							borderColor: 'red',
							borderWidth: 1,
							fill: false,
							data: [3, 12, 0]
						},
						{
							label: 'line2',
							borderColor: 'green',
							borderWidth: 1,
							fill: false,
							data: [10, -5, 3]
						}],
				},

				options: {
					responsive: true,
					animation: {duration: 0,},
					events: ['mousedown', 'mouseup', 'mousemove', 'mousewheel',],
					maintainAspectRatio: false,

					legend: {display: false,},

					tooltips: {display: false,},

					scales: {
						yAxes: [{
							type: 'linear',
							position: 'left',
							ticks: {},
						}]
					},

					plugins: {
						// select: {
						// 	events: ['mousedown', 'mouseup',],
						// 	selectCallback: function (startPoint, endPoint) {
						// 		console.debug('PlateRawChart.selectCallback()')
						// 	},
						// },
						zoom: {
							zoom: {
								enabled: true,
								drag: false,

								// Zooming directions. Remove the appropriate direction to disable
								// Eg. 'y' would only allow zooming in the y direction
								mode: 'y',

								rangeMin: {},
								rangeMax: {},
							},
							pan: {
								enabled: true,
								mode: 'y',
								//speed: 10,
								//threshold: 10
							},
						}
					}
				}
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			plate: {type: Plate, default: () => Plate.empty_plate,},
			selected_wells: {type: Array, default: () => []},
			hovered_well: {type: Number, default: -1,},
			point: {type: Number, default: 0,}
		},

		watch: {

			plate: function (new_value, old_value) {
				console.debug(format("PlateRawChart.watch.plate() plate_id={0}", this.plate.id))

				this.update_chart()
			},

			selected_wells: function (new_wells, old_wells) {
				console.debug(format(
					"PlateRawChart.watch.selected_wells( {0} ) plate_id={1}",
					JSON.stringify(this.selected_wells), this.plate.id))

				this.update_chart()
			},

			hovered_well: function (new_value, old_value) {
				// console.debug(format(
				// 	"PlateRawChart.watch.hovered_well( {0} )",
				// 	this.hovered_well))

				if (!this.disabled) {
					this.loading_promise
						.then(() => {
							let updated = false

							if (this.selected_wells.indexOf(old_value) !== -1) {
								this.update_well_chart(old_value)
								updated = true
							}

							if (this.selected_wells.indexOf(new_value) !== -1) {
								this.update_well_chart(new_value)
								updated = true
							}

							if (updated) {
								this.refresh()
								// console.debug(format("PlateRawChart.watch.hovered_well( {0} ) end", this.hovered_well))
							}
						})
				}
			},

			point: function (new_value, old_value) {
				const me = this
				this.loading_promise
					.then(function () {
						me.update_chart()
					})
			},

			disabled: function (new_value, old_value) {
				console.debug(format("PlateRawChart.watch.disabled({0})", this.disabled))

				const me = this
				this.loading_promise
					.then(function () {
						setTimeout(function () {
							me.update_chart()
						}, 100)
					})
			},
		},

		computed: {
			txtToClipboard: function () {
				console.debug("PlateRawChart.computed.txtToClipboard()")

				let txt = ''


        this.selected_wells.map()
				for (const point of this.plate.points) {


					for (const well_num of this.selected_wells) {
						let k = 12
					}
				}
				return txt
			},
		},

		created() {
			this.store_mutation_unsubscriber = this.$store.subscribe(
				this.store_mutation_handler)

			this.loading_promise = Promise.resolve()
		},

		destroyed() {
			this.store_mutation_unsubscriber()
		},

		mounted() {
			console.debug("PlateRawChart.mounted()")

			this.addPlugin(zoomPlugin)
			// this.addPlugin(selectPlugin)
			this.addPlugin(zoomPlugin)

			this.refresh()
		},

		methods: {
			...mapActions({
				message_add: 'message/add',
			}),

			store_mutation_handler: function (mutation, state) {
				try {
					if (mutation.type === 'plate/' + LOAD_WELL_SPECTRA) {
						const well_num = mutation.payload.well.well_num

						this.load_well_spectra(well_num)
					}
				} catch (error) {
					// нельзя выбрасывать исключения в обработчиках мутаций,
					// иначе в action случится повторная установка данных на пустые
					console.error("Catching any error on mutation handling.")
					console.error(error)
					//console.trace()
				}
			},

			/**
			 * При получении данных лунки добавляем их
			 * в рисуемые данные и обновляем рисовалку
			 * @param well_num
			 */
			load_well_spectra: function (well_num) {

				console.debug(format(
					"PlateRawChart.load_well_spectra( #{well_num} )",
					{well_num: well_num}))

				// const well = this.plate.wells[well_num]

				// // для проверки двойной загрузки данных лунок
				// if (!(well_num in this.loaded_wells)) {
				// 	this.loaded_wells[well_num] = well
				// } else {
				// 	console.error(format("Double loaded #{0}", well_num))
				// }

				this.update_well_chart(well_num)

				this.refresh()
			},

			get_well_dataset: function (well) {


			},

			get_well_spectra: function (well) {

				const point_spectra = well.spectra != null
					? well.spectra[this.point]
					: []

				let res = {
					tension: 0,
					// label: 'line1',
					borderColor: well.color !== null && well.color !== ''
						? well.color : '#000000' + '40',
					borderWidth: 1,
					pointRadius: 1,
					pointHoverRadius: 2,
					fill: false,
					data: point_spectra
				}

				if (well.well_num === this.hovered_well) {
					res.borderWidth = 3
					res.borderColor = well.color !== null && well.color !== ''
						? well.color : '#800000'
				}

				return res
			},

			update_well_chart: function (well_num) {
				const well = this.plate.wells[well_num]
				const well_base = this.wells[well_num]

				this.data.datasets[well_base] =
					well.spectra != null
						? this.get_well_spectra(well)
						: {}

				// if (well.spectra != null && well.spectra.length > 0) {
				// 	this.data.datasets[this.wells[well_num]] = this.get_well_dataset(well)
				// }
			},

			/**
			 * Перестраиваем структуру рисуемых данных,
			 * при изменении списка выделенных лунок,
			 * при замене планшеты,
			 */
			update_chart: function () {
				console.debug("PlateRawChart.update_chart()")

				Promise.all([
					this.loading_promise,
					new Promise((resolve) => {
						let loading_wells = []
						for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
							const well_num = this.selected_wells[sw_i]
							if (this.plate.wells[well_num].spectra === null) {
								loading_wells.push(well_num)
							}
						}
						resolve(loading_wells)
					})])
					.then(([, loading_wells]) => {
						// заполним список лунок, для которых нужно загрузить данные
						this.loading_promise = Promise.all(
							// TODO: отправлять один запрос на обновление всех лунок
							loading_wells.map((well_num) => {
								return this.plate.wells[well_num].load_spectra(this.$store.dispatch)
							}))
							.then((response_list) => {
								console.debug("PlateRawChart.update_chart() .then")
								this.update_chart_datasets()
							})
							.catch((error) => this.message_add(error))
							.finally(() => null)

						return this.loading_promise
					})
			},

			update_chart_datasets: function () {
				console.debug("PlateRawChart.update_chart_datasets()")

				this.data.labels = this.plate.filtersets

				this.wells = {}
				// this.loaded_wells = {}

				this.data.datasets = new Array(this.selected_wells.length)

				// Fill in chart dataset items with {}
				for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
					const well_num = this.selected_wells[sw_i]
					this.wells[well_num] = sw_i

					if (well_num in this.plate.wells) {
						const well = this.plate.wells[well_num]
						this.data.datasets[sw_i] = {}
					}
				}

				if (!this.disabled) {
					for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
						const well_num = this.selected_wells[sw_i]
						const well = this.plate.wells[well_num]

						if (well.spectra) {
							this.update_well_chart(well_num)
						}
					}
				}

				this.refresh()
			},

			refresh: function () {
				const me = this

				if (!this.disabled) {
					if (this.$refs.canvas) {

						if (this.$data._chart !== null) {
							// сохраним окно координат при перерисовке
							const y_min = this.$data._chart.scales['y-axis-0'].min
							const y_max = this.$data._chart.scales['y-axis-0'].max
							if (y_min !== 0 && y_max !== 1) {
								this.options.scales.yAxes[0].ticks.min = y_min
								this.options.scales.yAxes[0].ticks.max = y_max
							}
						}
						this.renderChart(this.data, this.options)

					} else {
						console.warn(format(
							"PlateRawChart.refresh( this='{0}', this.$refs.canvas={1} )",
							me.constructor.name,
							this.$refs.canvas))
					}
				}
			},

			reset: function () {
				try {
					console.debug(format(
						"PlateRawChart.reset() {0}",
						JSON.stringify({
							plate_spectra_min: this.plate.spectra_min,
							plate_spectra_max: this.plate.spectra_max,
						})))

					this.options.scales.yAxes[0].ticks.suggestedMin = this.plate.spectra_min
					this.options.scales.yAxes[0].ticks.suggestedMax = this.plate.spectra_max
					this.options.plugins.zoom.zoom.rangeMin.y = this.plate.spectra_min
					this.options.plugins.zoom.zoom.rangeMax.y = this.plate.spectra_max

					this.$data._chart.resetZoom()
				} catch (error) {
					this.message_add(error)
				}
			},

		},
	}

</script>